import * as THREE from 'three';
import { disposeO3D, disposeO3D_child } from './threejsHelper';
import stop_png from '@/components/images/stop_logo.png';
import { getVirtualTypeName } from '@/utils/enumHelper.js';
import { getCenter, getHeading } from '@/utils/polygonHelper.js';
import { createSpriteTextList, createSpriteText, createSpriteText_map } from '@/utils/labeltext';

let group_virtual_obstacle = null;
let map_virtual_obstacle_model = new Map();
let material_box = null;
let material_box_side = null;
let material_box_2 = null; // 全局材质实例，用于 createBox_2，避免叠加加深
let texture_stop_logo = null;
let promise_stop_logo = null;
let group_visible = true;
let group_custom_zones = null;
let map_custom_zones = new Map();

export const render_virtual_obstacle = (vehicleData, scene_param) => {
  if (
    vehicleData?.planning?.virtualObstaclesList &&
    vehicleData?.planning?.virtualObstaclesList.length > 0
  ) {
    //新型虚拟障碍物存在的话，优先加载这个类型
    render_virtual_level_2(vehicleData, scene_param);
  } else if (vehicleData?.planning?.virtualObstacleList) {
    //新型虚拟障碍物不存在时，使用老的；
    render_virtual_level_1(vehicleData, scene_param);
  }
};

const createLabel = (obstacle) => {
  let textList = [];
  textList.push(`ID：${obstacle.id}`);
  textList.push(`TYPE:vObs`);
  obstacle.relativeObstacleIdList.forEach((rel) => {
    textList.push(rel);
  });
  let element = createSpriteTextList(textList, 30);
  element.position.set(
    obstacle.centerPosition.x,
    obstacle.centerPosition.y,
    obstacle.height - 0.5,
  );
  element.name = 'virtual_obstacle_label';
  group_virtual_obstacle.add(element);
};

const create_virtual_obstacle = (virtualObstacleList) => {
  virtualObstacleList.forEach((e) => {
    createLabel(e);
    let box = createBox(e);

    if (group_virtual_obstacle) {
      box.position.set(e.centerPosition.x, e.centerPosition.y, e.height / 2);
      box.rotation.set(0, 0, e.heading);
      box.name = 'virtual_obstacle_box';
      group_virtual_obstacle.add(box);
      group_virtual_obstacle.deleteIndex = 4;
    }
  });
};

function createBox(obstacle) {
  if (!material_box) {
    material_box = new THREE.MeshBasicMaterial({ color: 0xf05b72 });
    material_box.opacity = 0.3;
    material_box.transparent = true;
  }
  if (!material_box_side) {
    material_box_side = new THREE.MeshBasicMaterial({ color: 0xf05b72 });
  }
  let { length, height, width } = obstacle;
  const geometry = new THREE.BoxGeometry(length, width, height);
  const box = new THREE.Mesh(geometry, material_box);

  const edges = new THREE.EdgesGeometry(geometry);
  const box_side = new THREE.LineSegments(edges, material_box_side);
  box.add(box_side);
  createBox_topLogo(obstacle, box);
  return box;
}

const getStopTexture = () => {
  if (!promise_stop_logo) {
    promise_stop_logo = new Promise((resolve, reject) => {
      const loader = new THREE.TextureLoader();
      loader.load(
        stop_png,
        (texture) => {
          const material = new THREE.MeshBasicMaterial({
            map: texture,
            transparent: true,
          });
          resolve(material);
        },
        undefined,
        function (err) {
          console.error(err);
          reject(err);
        },
      );
    });
  }
  return promise_stop_logo;
};

function createBox_topLogo(obstacle, box) {
  if (!box) return;
  getStopTexture().then((material) => {
    let { length, height, width } = obstacle;
    if (length > width) {
      const geometry = new THREE.BoxGeometry(length / 4, 0.01, height / 4);
      const stoplogo = new THREE.Mesh(geometry, material);
      stoplogo.position.set(0, -width / 2, 0);
      box.add(stoplogo);
    } else {
      const geometry = new THREE.BoxGeometry(0.01, width / 4, height / 4);
      const stoplogo = new THREE.Mesh(geometry, material);
      stoplogo.position.set(-length / 2, 0, 0);
      box.add(stoplogo);
    }
  });
  // return box;
}

function render_virtual_level_1(vehicleData, scene_param) {
  if (vehicleData?.planning?.virtualObstacleList) {
    let list = vehicleData?.planning?.virtualObstacleList;
    if (list.length > 0) {
      if (!group_virtual_obstacle) {
        group_virtual_obstacle = new THREE.Group();
        group_virtual_obstacle.position.set(
          vehicleData.origin.x,
          vehicleData.origin.y,
          0,
        );

        group_virtual_obstacle.visible = true;
        scene_param.add(group_virtual_obstacle);
      } else {
        group_virtual_obstacle.children.forEach((e) => {
          disposeO3D(e);
        });
        group_virtual_obstacle.children = [];
        group_virtual_obstacle.position.set(
          vehicleData.origin.x,
          vehicleData.origin.y,
          0,
        );
      }
      Promise.resolve().then(() => {
        create_virtual_obstacle(list);
      });
    } else {
      if (group_virtual_obstacle) {
        group_virtual_obstacle.deleteIndex--;
        if (group_virtual_obstacle.deleteIndex < 0) {
          group_virtual_obstacle.children.forEach((e) => {
            disposeO3D(e);
          });
          group_virtual_obstacle.children = [];
        }
      }
    }
  }
}

function render_virtual_level_2(vehicleData, scene_param) {
  let list = vehicleData?.planning?.virtualObstaclesList;
  if (list.length > 0) {
    if (!group_virtual_obstacle) {
      group_virtual_obstacle = new THREE.Group();
      group_virtual_obstacle.visible = true;
      scene_param.add(group_virtual_obstacle);
    } else {
      // 找出需要删除的 box（在新列表中不存在的 id）
      const newIds = new Set(list.map(item => item.id));
      for (let [id, model] of map_virtual_obstacle_model) {
        if (!newIds.has(id)) {
          // 删除不再需要的 box
          disposeO3D(model);
          map_virtual_obstacle_model.delete(id);
        }
      }
    }
    Promise.resolve().then(() => {
      create_virtual_obstacle_2(list, vehicleData.origin);
    });
  } else {
    if (group_virtual_obstacle) {
      group_virtual_obstacle.deleteIndex--;
      if (group_virtual_obstacle.deleteIndex < 0) {
        for ([key, modle] of map_virtual_obstacle_model) {
          disposeO3D(modle);
        }
        map_virtual_obstacle_model.clear();
        group_virtual_obstacle.children = [];
      }
    }
  }
}

const create_virtual_obstacle_2 = (virtualObstacleList, origin) => {
  virtualObstacleList.forEach((e) => {
    // 如果已存在该 id 的 box，先删除它
    if (map_virtual_obstacle_model.has(e.id)) {
      const oldModel = map_virtual_obstacle_model.get(e.id);
      disposeO3D(oldModel);
      map_virtual_obstacle_model.delete(e.id);
    }
    
    let isRender = false;
    e.polygon?.polygonPointList?.forEach((point, index) => {
      if (point.x < 200 || point.y < 200) {
        isRender = true;
      }
    });
    if (isRender) {
      let box = createBox_2(e);
      let label = createLabel_2(e, box);
      if (group_virtual_obstacle) {
        // box.position.set(e.centerPosition.x, e.centerPosition.y, e.height / 2)
        // box.rotation.set(0, 0, e.heading)
        box.name = 'vir_obs_box';
        box.position.set(origin.x, origin.y, -0.1);
        group_virtual_obstacle.add(box);
        group_virtual_obstacle.deleteIndex = 4;
        map_virtual_obstacle_model.set(e.id, box);
      }
    }
  });
};

function createBox_2(obstacle, origin) {
  if (!material_box_2) {
    material_box_2 = new THREE.MeshBasicMaterial({ 
      color: 0x843900, 
      opacity: 0.1, 
      transparent: true, 
      side: THREE.DoubleSide,
      depthWrite: false,
      depthTest: false,
    });
  }
  
  if (!material_box_side) {
    material_box_side = new THREE.MeshBasicMaterial({ color: 0xf05b72 });
  }
  //
  const shape = new THREE.Shape();
  shape.autoClose = true;
  obstacle.polygon.polygonPointList.forEach((e, index) => {
    if (index == 0) {
      shape.moveTo(e.x, e.y);
    } else {
      shape.lineTo(e.x, e.y);
    }
  });
 
  let depth = 2;
  if (obstacle.virtualType == 10) {
    depth = 0.1;
  }
  const extrudeSettings = {
    depth,
    bevelEnabled: false,
  };
  const geometry = new THREE.ExtrudeGeometry(shape, extrudeSettings);
  const box = new THREE.Mesh(geometry, material_box_2);
  // 设置统一的渲染顺序，确保所有虚拟障碍物在同一层级渲染
  // box.renderOrder = 0;
  const edges = new THREE.EdgesGeometry(geometry);
  const box_side = new THREE.LineSegments(edges, material_box_side);
  box.add(box_side);
  return box;
}

const createLabel_2 = (obstacle, box) => {
  let textList = [];
  let typeName = getVirtualTypeName(obstacle.virtualType);
  // let text = `ID:${obstacle.id};\n type:${typeName};\n`;
  textList.push(`ID:${obstacle.id}`);
  textList.push(`type:${typeName}`);
  let center = getCenter(obstacle.polygon.polygonPointList);
  // let element = createSpriteText(textList, 12);
  let element = createSpriteText(textList, 30);
  element.up = new THREE.Vector3(0,0,1);
  element.position.set(center.x, center.y, 2.5);
  // element.rotateX(Math.PI / 2)//obstacle.heading+Math.PI/2
  // let heading = getHeading(obstacle.polygon.polygonPointList);
  // element.rotateY(heading)
  element.name = 'virtual_obstacle_label';
  box.add(element);
};

// 控制虚拟障碍物隐藏
export const visible_virtual_obstacle_sign = (visible)=>{
  if(group_virtual_obstacle){
    group_virtual_obstacle.visible = visible;
  }
}

// 清理所有已渲染的虚拟障碍物 box
export const clear_virtual_obstacle = () => {
  if (group_virtual_obstacle) {
    // 清理所有已渲染的 box
    for (let [key, model] of map_virtual_obstacle_model) {
      disposeO3D(model);
    }
    map_virtual_obstacle_model.clear();
    disposeO3D_child(group_virtual_obstacle);
    group_virtual_obstacle.children = [];
  }
}

export const render_custom_zones = (list, scene) => {
  if (!list || list.length === 0) {
    return;
  }
  
  if (!group_custom_zones) {
    group_custom_zones = new THREE.Group();
    group_custom_zones.visible = true;
    scene.add(group_custom_zones);
  }

  const newIds = new Set();
  list.forEach(item => {
    const id = item.uuid || item.id;
    if (id) newIds.add(id);
  });

  for (let [id, model] of map_custom_zones) {
    if (!newIds.has(id)) {
      disposeO3D(model);
      group_custom_zones.remove(model);
      map_custom_zones.delete(id);
    }
  }

  list.forEach(item => {
    const id = item.uuid || item.id;
    if (id && !map_custom_zones.has(id)) {
      if (item.points && item.points.length > 0) {
        // 根据 buildTaskStatus 设置颜色：-1 是黄色（低饱和度），其他状态都是绿色（低饱和度）
        const color = item.buildTaskStatus === -1 ? 0x843900 : 0x18c918;
        const box = createBoxFromPoints(item.points, color);
        
        // 分行展示完整 UUID / ID；画布宽度由 createSpriteText_map 按文本动态计算，避免截断
        const labelLines = [];
        if (item.uuid) labelLines.push(`UUID: ${item.uuid}`);
        if (item.id != null && item.id !== '') labelLines.push(`ID: ${item.id}`);
        if (labelLines.length > 0) {
           const center = getCenter(item.points);
           const label = createSpriteText_map(labelLines, 200, '#ffffff', 200, 200);
           label.material.depthTest = false;
           label.material.transparent = true;
           label.renderOrder = 200;
           label.up = new THREE.Vector3(0,0,1);
           label.position.set(center.x, center.y, 0.1);
           box.add(label);
        }
        box.name = `custom_zone_${id}`;
        box.position.set(0, 0, 0.2);
        
        group_custom_zones.add(box);
        map_custom_zones.set(id, box);
      } else {
        console.warn('Item has no points or empty points array');
      }
    }
  });
}

export const createBoxFromPoints = (points, color = 0x18c918) => {
  const shape = new THREE.Shape();
  shape.autoClose = true;
  points.forEach((e, index) => {
    if (index === 0) {
      shape.moveTo(e.x, e.y);
    } else {
      shape.lineTo(e.x, e.y);
    }
  });
  
  // 为每个区域创建独立的材质，支持不同颜色
  const material = new THREE.MeshBasicMaterial({ 
      color: color, 
      opacity: 0.3, 
      transparent: true, 
      side: THREE.DoubleSide,
      depthWrite: false,
      depthTest: true,
  });
  
  // 创建 2D 平面用于地面区域标记
  const geometry = new THREE.ShapeGeometry(shape);
  const box = new THREE.Mesh(geometry, material);
  
  return box;
}

export const clearFreeAreaModel = () => {
  if (group_custom_zones) {
      for (let [key, model] of map_custom_zones) {
          disposeO3D(model);
      }
      map_custom_zones.clear();
      disposeO3D_child(group_custom_zones);
      group_custom_zones.children = [];
  }
}